// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/locale-provider/style/index.less
// module id = 872
// module chunks = 1